import { z } from 'zod';

export const outreachProgramSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(2, 'Program name is required'),
  description: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  location: z.object({
    name: z.string(),
    address: z.string(),
    coordinates: z.object({
      lat: z.number(),
      lng: z.number(),
    }).optional(),
  }),
  status: z.enum(['planned', 'active', 'completed', 'cancelled']),
  type: z.string().min(2, 'Program type is required'),
  targetParticipants: z.number().min(1),
  actualParticipants: z.number().optional(),
  budget: z.number().optional(),
  staff: z.array(z.object({
    id: z.string(),
    name: z.string(),
    role: z.string(),
  })),
  metrics: z.object({
    patientsServed: z.number().optional(),
    servicesProvided: z.number().optional(),
    satisfactionRate: z.number().optional(),
  }).optional(),
});

export type OutreachProgram = z.infer<typeof outreachProgramSchema>;
